import routeIcon from "../assets/images/gis_route.svg";
import { SHIPMENT_SCOPE } from "../util/quotationUtil";
import { useFieldArray } from "react-hook-form";
import { Cargo, Container, enquiryStore } from "../enquiry/enquiry-data";
import { AgMuiUn } from "../mui-components/AgAutoComplete";
import LabeledTextField from "../mui-components/LabeledTextField";
import { Add} from "@mui/icons-material";
import deleteicon from "../assets/images/deletei.svg";
import { ControlledDetailSwitch } from "./AgControlledDetailSwitch";
import { LabeledRadioButton } from "./AgLabeledRadioButton";
import RoleUtils from "../util/RoleUtils";
import { AgmodalStore, filtersState, quoteDataRec } from "../state/CommonState";
import { useSnapshot } from "valtio";
import { useEffect, useState } from "react";
import { PERMISSIONS, PERMISSIONS_NEW } from "../util/constants";
import { useGlobalState } from "../GlobalState";
import { warehouses } from "../StaticData";
import { useMobile } from "../hooks/usemobile";
import TenantUtils from "../util/tenant.utils";



export function Route({form,viewonly=false,edit=false,validateAddress=true,callback = (f) => f,enableCrn=false,carting=false,cwfVisible=false}){
    useSnapshot(AgmodalStore)
    useSnapshot(quoteDataRec)
    const shipmentScopes = Object.values(SHIPMENT_SCOPE);
    const { control, watch, register, setValue, handleSubmit, reset,resetField, clearErrors, formState, trigger, getFieldState,getValues } = form;
    const { fields: multidest, append: appendMulitdest, remove: removeMultidest } = useFieldArray({
        control: control,
        name: "multidest"
    })
    const shipmentType = watch("mode");
    const Scope = watch("scope")
    const isFba = watch("isFba"); 
    const watchWarehouse = watch("warehouse");
    const fbaalways = watch("fbaalways"); 
    const stuffing = watch("stuffingType");
    const deStuffing = watch("destuffingType");
    const outGuage = watch("showCargoDetailsOutGuage")
    const originDoor = watch("originDoor")
    const originTmp = watch("originTmp")
    const origin = watch("origin")
    const destinationDoor = watch("destinationDoor")
    const destinationTmp = watch("destinationTmp")
    const multidestvalue = getValues("multidest")?getValues("multidest"):watch("multidest")
    const [destcountry, setDestcountry] = useState("")
    const [warehouse,setWarehouse] = useState(watchWarehouse||"AMAZON");
    const isMobile = useMobile()
    
    useEffect(()=>{
        if(multidestvalue!=undefined && multidestvalue?.length>0){
            setDestcountry(multidestvalue[0]?.destination)
        }
    },[JSON.stringify(multidestvalue)])
    const { currentMenu } = useGlobalState();
    let showCargoDetail = false;
    let destination = Scope?.split("-")[2];
    if(destination?.toLowerCase()==="door"){
        if((shipmentType.toLowerCase() === "fcl" && deStuffing.toLowerCase() === "dock" ) || shipmentType.toLowerCase() != "fcl"){
            showCargoDetail = true;
        }
    }else{
        if(showCargoDetail) showCargoDetail = false;
    }
    const validateGreaterThanZero = (value) => {
        return (value!=undefined && value.length!=0) || 'Required';
    };
    const [crn,setCrn] = useState(false)
    useEffect(()=>{
        if(!RoleUtils.isUserAuthorized(PERMISSIONS_NEW.BOOKINGS.UPDATE_CUST_REF_NUMBER)){
            if(!crn){
                setCrn(true)
            }
        }
        if ((currentMenu == "Quotationv3" || currentMenu == "Enquiriesv3" || currentMenu == "Spot Booking WIP" || currentMenu=="Carting Sheet") && crn) {
            setCrn(false)
        }
        if(!crn && AgmodalStore.modalPage=='ViewEnquiry-v3'){
            setCrn(true)
        }
        if(enableCrn){
            setCrn(false)
        }
    },[AgmodalStore])

useEffect(()=>{
    if(watchWarehouse){
         setWarehouse(watchWarehouse)
    }
},[watchWarehouse])

useEffect(()=>{
   if(shipmentType?.toLowerCase().includes("fcl") || shipmentType?.toLowerCase().includes("air")){
    setValue("volumeInDimensions",true);
   }
},[shipmentType])

    return  <div className={`flex flex-col min-h-[304px] ${isMobile?"w-full":"w-[431px]"}`}>
    <div className="flex flex-col min-h-[304px] max-h-max w-full rounded-md bg-white shadow-custom p-[18px] gap-[16px]">
        <div className="flex flex-row justify-between items-center">
        <div className="flex flex-row gap-[10px]">
           <img src={routeIcon}/>
           <p className="text-black font-bold">Route</p>
        </div>
        {((fbaalways!=undefined && fbaalways=='Yes') || ((shipmentType==="LCL" || shipmentType.toLowerCase().indexOf("fcl")!=-1) && (Scope==="Port-to-Door" || Scope==="Door-to-Door"))) && <ControlledDetailSwitch control={control} isChecked={isFba} formKey="isFba"  title="Fulfilment Center" disable={viewonly} onChange={(val)=>{
          filtersState.initialize();
          if(val){
            setValue("warehouse",warehouse);
          }else{
            setValue("warehouse",undefined);
          }
          setValue("multidest", [
                {
                    destination:"",
                    cargoDetails:[new Cargo()],
                }
            ]);
            setValue("containerDetails",[new Container()])
        }}/>}
        </div>
       { carting || viewonly || quoteDataRec.quotationNum !== "" ? <div className="flex flex-row gap-2">
          <p className="text-blue-light font-bold font-roboto">{shipmentType}</p>
          <p className="text-blue-dark font-bold font-roboto">-</p>
          <p className="text-blue-dark font-bold font-roboto"> {Scope}</p>
       </div>  : <div className="grid grid-cols-2 min-h-[67px] h-auto place-content-stretch">
            {shipmentScopes.map((scope)=><LabeledRadioButton label={scope} selected={Scope===scope} onClick={()=>{
                filtersState.initialize();
                if(!viewonly){
                    let s = Scope.split('-to-')
                    let s1 = scope.split('-to-')
                    if(s[0]!=s1[0]){
                        setValue("origin", "");
                    }
                    if(TenantUtils.isNavexel()){
                        if(s1[0]=='Port' && currentMenu=="Spot Booking WIP"){
                            setValue("origin","Nhava Sheva, India (INNSA)")
                        }
                    }
                    if(s[1]!=s1[1]){
                        let m = JSON.parse(JSON.stringify([multidestvalue[0]]))
                        m[0]['destination'] = ""
                        if((shipmentType.toLowerCase()=='lcl' && ((Scope.indexOf('Door')!=-1 && scope.indexOf('Door')==-1) || (Scope.indexOf('Door')==-1 && scope.indexOf('Door')!=-1))) ||
                           (shipmentType.toLowerCase()=='fcl' && ((stuffing!='Factory' && s[0]==s1[0] && s[0]!='Door') || (deStuffing!='Factory' && s[1]==s1[1] && s[1]!='Door') || scope=='Port-to-Port'))){
                           m[0]['cargoDetails'] = [new Cargo()]
                        }
                        setValue("multidest", m);
                    }
                    if(shipmentType.toLowerCase()!='fcl'){
                        setValue("containerDetails",[new Container()])
                    }
                    setValue("scope", "");
                    // setValue("stuffingType","Factory")
                    // setValue("destuffingType","Factory")
                    if(fbaalways=='No' && isFba){
                        setValue("isFba",false)
                    }
                    setTimeout(()=>{
                        setValue("scope", scope);
                    },1)
                    clearErrors();
                }
                
            }} />)}
        </div>}
        { multidest.length>1 && <p className="text-blue-light font-bold">Origin Details</p>}
        <div className="flex flex-col w-full gap-[4px]">    
        <p className="text-xs font-bold" style={{ color: process.env.REACT_APP_ENTERPRISE_COLOUR }}>{(!viewonly && originDoor) && "Select"} Origin * {carting && cwfVisible && <ControlledDetailSwitch
                                    control={control}
                                    isChecked={originDoor}
                                    formKey={"originDoor"}
                                    title={"Door"}
                                    onChange={(e)=>{
                                        if(e){
                                            setValue("originTmp",origin)
                                            setValue("origin","")
                                            let s = Scope?.split("-")
                                            s[0] = "Door"
                                            setValue("scope",s.join('-'))
                                            setValue("volumeInDimensions",false)
                                        }else{
                                            setValue("origin",originTmp)
                                            let s = Scope?.split("-")
                                            s[0] = "Port"
                                            setValue("scope",s.join('-'))
                                        }
                                    }}
                                  />}</p>
        <AgMuiUn warehouse={warehouse} onChange={async ()=>{
            filtersState.initialize();
            await trigger([`origin`]);
        }} getValues={getValues} clearErrors={clearErrors} trigger={trigger} validateAddress={validateAddress} getFieldState={getFieldState} placeholder="Choose Origin" key={"origin"} rules={{ required: "Origin is Required" }} isDoor={Scope === SHIPMENT_SCOPE.D2D || Scope === SHIPMENT_SCOPE.D2P} control={control} name="origin" disabled={!edit && viewonly && !originDoor} />
        </div>
        {isFba && <div className="flexx flex-col gap-3">
                <p className="text-xs font-bold" style={{ color: process.env.REACT_APP_ENTERPRISE_COLOUR }}>{!viewonly && "Choose"} Warehouse</p>
                <div className="grid grid-cols-2 place-content-stretch">
                    {warehouses.map((house)=><LabeledRadioButton label={house.label} selected={warehouse===house.value} onClick={()=>{
            if(!viewonly){
                setWarehouse(house.value)
                setValue("warehouse",house.value)
                let destinationClearedMultidest = multidest.map((dest)=>({...dest,destination:""}))
                setValue("multidest",destinationClearedMultidest);
            }
        }} />)}
                </div>
            </div>}
        { multidest.length>1 && <p className="text-blue-light font-bold">Destination Details</p>}
        {multidest.map((m,i)=>{
            return <div className="flex flex-col w-full gap-[4px]">
                {
                    (multidest.length>1)?<p className="text-xs font-bold" style={{ color: process.env.REACT_APP_ENTERPRISE_COLOUR }}>{!viewonly && "Select"} Destination {i+1} *</p>:<p className="text-xs font-bold" style={{ color: process.env.REACT_APP_ENTERPRISE_COLOUR }}>Select Destination * {carting && cwfVisible && <ControlledDetailSwitch
                                    control={control}
                                    isChecked={destinationDoor}
                                    formKey={"destinationDoor"}
                                    title={"Door"}
                                    onChange={(e)=>{
                                        if(e){
                                            setValue("destinationTmp",destcountry)
                                            setValue("multidest.0.destination","")
                                            let s = Scope?.split("-")
                                            s[2] = "Door"
                                            setValue("scope",s.join('-'))
                                            setValue("volumeInDimensions",false)
                                        }else{
                                            setValue("multidest.0.destination",destinationTmp)
                                            let s = Scope?.split("-")
                                            s[2] = "Port"
                                            setValue("scope",s.join('-'))
                                        }
                                    }} />}</p>
                }
            
            <div className="flex flex-col w-full gap-[4px]">
                <div className="flex flex-row justify-between items-center"><AgMuiUn setValue={setValue} warehouse={warehouse}  onChange={()=>{
            filtersState.initialize();
        }} id={i} getValues={getValues} clearErrors={clearErrors} trigger={trigger} getFieldState={getFieldState} validateAddress={validateAddress} placeholder={isFba? `Enter ${warehouses.find(({value})=>value===warehouse).label} Warehouse Code` : "Choose Destination"} key={m.id} rules={{ required: "Destination is Required" }} isDoor={Scope === SHIPMENT_SCOPE.D2D || Scope === SHIPMENT_SCOPE.P2D} control={control} name={`multidest.${i}.destination`} disabled={!edit && viewonly && !destinationDoor} doorCountry={destcountry} isFba={isFba}/>
                { !viewonly && multidest.length>1 &&
        <div onClick={()=>{
            filtersState.initialize();
            removeMultidest(i);
        }} className="w-[35px] h-full flex items-center justify-center cursor-pointer">
    <img src={deleteicon}/>
        </div>
             }
            </div>
            </div></div>
        }
        
        )}
        {
            process.env.REACT_APP_ENTERPRISE_NAME_SMALLCASE === 'agraga' && multidest.length<5 && showCargoDetail && <div className="flex flex-col w-full gap-[4px]">
            { !viewonly &&
           <button onClick={()=>{
            filtersState.initialize();
        let dest = {
            destination:"",
            cargoDetails:[new Cargo()],
        }
                appendMulitdest({ ...dest });
            }} type="button" className="bg-[#F7F7F7] border-[1px] border-solid border-[#E8E8E8] h-[35px] rounded-[6px]">
                <div className="flex h-full w-full flex-row gap-[5px] justify-center items-center font-bold">
                    <Add sx={{fontSize:"22px",color:process.env.REACT_APP_ENTERPRISE_COLOUR}}/>
                    <p className="text-grey">Add Destination</p>
                </div>
            </button>}
            </div>
        }
        
        <div className={`grid ${isMobile?"grid-cols-1 h-auto":"grid-cols-2 h-[67px]"} gap-3 place-content-stretch`}>
        <LabeledTextField labelStyle={{fontSize:"12px",color:process.env.REACT_APP_ENTERPRISE_COLOUR,fontWeight:"bold"}} label="Cargo Readiness Date" control={control}  inputProps={{ min: new Date().toISOString().split('T')[0] }} name="cargoreadinessdate" type="date" size="small" fullWidth disabled={viewonly} rules={{ required: "Required", validate: validateGreaterThanZero }}/>
        <LabeledTextField labelStyle={{fontSize:"12px",color:process.env.REACT_APP_ENTERPRISE_COLOUR,fontWeight:"bold"}} label="Customer Reference Number"  control={control} name="customerreference" disabled={crn} onBlur={(e)=>{
            enquiryStore.current.enqRoute.customerReferenceNum = e
            callback(e)
        }}/>
        </div>
    </div>
    </div>
}